import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import {Configuration} from "../../../assets/Configuration";
import {TrainingCategoryFullModel, TrainingCategoryFileModel, TrainingCategoryModel, TrainingCategorySummaryModel} from "../../models/training-category/training-category.model";
import {TrainingCategoryCreationAndUpdateModel} from "../../models/training-category/training-category-creation-and-update.model";
import { RawFileModel } from '../../models/raw-file-model';
import { TrainingCategoryOverviewModel } from '../../models/training-category/training-category-overview.model';

@Injectable({
  providedIn: 'root'
})
export class TrainingCategoryService {

  constructor(private httpClient: HttpClient) {
  }

  public getAllTrainingCategoriesFull(): Observable<TrainingCategoryFullModel[]> {
    return this.httpClient.get<TrainingCategoryFullModel[]>(Configuration.getApiBaseUrl() + "/trainingcategory/full");
  }

  public getAllTrainingCategoriesOverview(): Observable<TrainingCategoryOverviewModel[]> {
    return this.httpClient.get<TrainingCategoryOverviewModel[]>(
      Configuration.getApiBaseUrl() + "/trainingcategory/overview"
    );
  }

  public getAllTrainingCategories(): Observable<TrainingCategoryModel[]> {
    return this.httpClient.get<TrainingCategoryModel[]>(Configuration.getApiBaseUrl() + "/trainingcategory/");
  }

  
  public getTrainingCategoryFull(id: string): Observable<TrainingCategoryFullModel> {
    return this.httpClient.get<TrainingCategoryFullModel>(Configuration.getApiBaseUrl() + "/trainingcategory/" + id + "/full");
  }

  public getTrainingCategorySummary(id: string): Observable<TrainingCategorySummaryModel> {
    return this.httpClient.get<TrainingCategorySummaryModel>(Configuration.getApiBaseUrl() + "/trainingcategory/" + id + "/summary");
  }

  public getTrainingCategory(id: string): Observable<TrainingCategoryModel> {
    return this.httpClient.get<TrainingCategoryModel>(Configuration.getApiBaseUrl() + "/trainingcategory/" + id);
  }

  public getRequiredCourseIds(id: string): Observable<string[]> {
    return this.httpClient.get<string[]>(
      Configuration.getApiBaseUrl() + "/trainingcategory/" + id + "/required-courses"
    );
  }


  public addTrainingCategory(model: TrainingCategoryCreationAndUpdateModel): Observable<TrainingCategoryFullModel> {
    return this.httpClient.post<TrainingCategoryFullModel>(Configuration.getApiBaseUrl() + "/trainingcategory/", model);
  }

  public updateTrainingCategory(id: string, model: TrainingCategoryCreationAndUpdateModel): Observable<TrainingCategoryFullModel> {
    return this.httpClient.post<TrainingCategoryFullModel>(Configuration.getApiBaseUrl() + "/trainingcategory/" + id, model);
  }

  public deleteTrainingCategory(id: string): Observable<void> {
    return this.httpClient.delete<void>(Configuration.getApiBaseUrl() + "/trainingcategory/" + id);
  }

  public addTrainingCategoryFile(id: string, file: RawFileModel): Observable<TrainingCategoryFileModel> {
    return this.httpClient.post<TrainingCategoryFileModel>(Configuration.getApiBaseUrl() + "/trainingcategory/" + id + "/file", file);
  }

  public deleteTrainingCategoryFile(id: string, fileId: string): Observable<void> {
    return this.httpClient.delete<void>(Configuration.getApiBaseUrl() + "/trainingcategory/" + id + "/file/" + fileId);
  }
}
